import { IRootState } from "../redux/reducers/root";

export default function getHeaders(api: { getState: () => IRootState }) {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${api.getState().session.user.token?.access_token}`,
    };
}
